@if (headline()) {
  <div class="table-headline">
    <span>{{ headline() }}</span>
  </div>
}
@if (entryRows().length > 0) {
  <div class="table-body">
    @for (rowEntries of entryRows(); track $index) {
      <div class="table-row" [style.--row-entry-count]="rowEntries.length" [class.divider]="!$last">
        @for (entry of rowEntries; track $index) {
          <div class="table-column">
            <div class="cell-header">
              <span>{{ entry.title }}</span>
            </div>
            <div class="cell-content">
              @if (entry.contentTemplate) {
                <ng-container
                  [ngTemplateOutlet]="entry.contentTemplate"
                  [ngTemplateOutletContext]="entry.contentTemplateContext"
                ></ng-container>
              } @else {
                <span>{{ entry.content }}</span>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
